import React, { useState, useEffect } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { useDispatch, useSelector } from 'react-redux'
import { setAppId, selectedApplicationData } from '../../store/ApplicationSlice'
import { useNavigate } from 'react-router-dom'
import MenuList from '../../components/MenuList'
import axios from 'axios'

const EscalationOverview = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const appetiteData = useSelector(state => state.intakeData.appetiteData)
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  )
  const [tableData, setTableData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [highlightedRow, setHighlightedRow] = useState(0)
  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: null
  })
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const [comment, setComment] = useState('')

  const fetchData = async () => {
    const accessToken = localStorage.getItem('access_token')
    const refreshToken = localStorage.getItem('refresh_token')

    const headers = {
      'X-Access-Token': accessToken,
      'X-Refresh-Token': refreshToken,
      Accept: 'application/json'
    }
    try {
      const response = await axios.get(
        'https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v1/escalations',
        {
          params: { email_id: 'james_jones@nativeorange.com' },
          headers
        }
      )
      setTableData(response.data)
      setFilteredData(response.data)
      dispatch(setAppId(response.data[0]?.application_id)) // Assuming response.data is the array of objects
    } catch (error) {
      console.error('Error fetching conversations:', error)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const handleSort = column => {
    let direction = 'asc'
    if (sortConfig.column === column && sortConfig.direction === 'asc') {
      direction = 'desc'
    }

    const sortedData = [...filteredData].sort((a, b) => {
      const valueA = a[column]
      const valueB = b[column]

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return direction === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA)
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        return direction === 'asc' ? valueA - valueB : valueB - valueA
      } else {
        return 0 // Handles null or undefined values
      }
    })

    setFilteredData(sortedData)
    setSortConfig({ column, direction })
  }

  const handleCheckboxChange = (event, index, id) => {
    const isChecked = selectedCheckboxes.includes(id)
    const updatedCheckboxes = isChecked
      ? selectedCheckboxes.filter(item => item !== id)
      : [...selectedCheckboxes, id]

    setSelectedCheckboxes(updatedCheckboxes)
    setHighlightedRow(index)
  }

  const handleSelectAll = event => {
    if (event.target.checked) {
      // If checkbox is checked, select all checkboxes
      const allIds = filteredData.map(row => row.escalation_id)
      setSelectedCheckboxes(allIds)
    } else {
      // If checkbox is unchecked, clear all checkboxes
      setSelectedCheckboxes([])
    }
  }

  const handleSearch = e => {
    const searchValue = e.target.value.toLowerCase()
    setSearchTerm(searchValue)
    if (searchValue.length > 2) {
      const filtered = tableData.filter(row =>
        Object.values(row).some(value =>
          value.toString().toLowerCase().includes(searchValue)
        )
      )
      setFilteredData(filtered)
    } else {
      setFilteredData(tableData)
    }
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleApprove = async status => {

    const accessToken = localStorage.getItem('access_token')
    const refreshToken = localStorage.getItem('refresh_token')

    const headers = {
      'X-Access-Token': accessToken,
      'X-Refresh-Token': refreshToken,
      Accept: 'application/json'
    }
    try {
      const response = await axios.post(
        'https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v1/escalation',
        {
          escalation_id: selectedCheckboxes[0],
          escalation_status: status
        },
        {
          headers: headers
        }
      )
      fetchData()
      setSelectedCheckboxes([])
    } catch (error) {
      console.error('Error fetching conversations:', error)
    }
  }

  const handleRowDoubleClick = id => {
    let selectedData = appetiteData.find(
      application => application['application_id'] === id
    )
    dispatch(selectedApplicationData(selectedData))
    dispatch(setAppId(id))
    navigate(`/app/intake/${id}`)
  }

  return (
    <div className='mx-auto relative'>
      <div className='flex items-center space-x-4'>
        <MenuList isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <h1 className='py-2 text-2xl text-orange-600'>
          Referral List View
        </h1>
      </div>

      <div className='flex-grow transition-transform duration-300'>
        <div className='grid grid-cols-12 gap-4'>
          <div className='col-span-12'>
            <div
              className='overflow-x-auto intake-table-data'
              style={{ maxHeight: '500px' }}
            >
              <table className='min-w-full bg-white'>
                <thead className='bg-gray-200 table-header'>
                  <tr>
                    <th className='text-left py-3 px-4'>
                      <input
                        type='checkbox'
                        checked={
                          filteredData.length > 0 &&
                          selectedCheckboxes.length === filteredData.length
                        }
                        onChange={handleSelectAll}
                      />{' '}
                      Select All
                    </th>
                    <th
                      className='text-left py-3 px-4 cursor-pointer'
                      onClick={() => handleSort('applicant_name')}
                    >
                      Applicant Name
                      {sortConfig.column === 'applicant_name' &&
                        (sortConfig.direction === 'asc' ? (
                          <ArrowUpwardIcon />
                        ) : (
                          <ArrowDownwardIcon />
                        ))}
                    </th>

                    <th
                      className='text-left py-3 px-2 cursor-pointer'
                      onClick={() => handleSort('application_id')}
                    >
                      Application ID
                      {sortConfig.column === 'application_id' &&
                        (sortConfig.direction === 'asc' ? (
                          <ArrowUpwardIcon />
                        ) : (
                          <ArrowDownwardIcon />
                        ))}
                    </th>

                    <th
                      className='text-left py-3 px-4 cursor-pointer'
                      onClick={() => handleSort('product')}
                    >
                      Product
                      {sortConfig.column === 'product' &&
                        (sortConfig.direction === 'asc' ? (
                          <ArrowUpwardIcon />
                        ) : (
                          <ArrowDownwardIcon />
                        ))}
                    </th>
                    <th
                      className='text-left py-3 px-4 cursor-pointer'
                      onClick={() => handleSort('agent')}
                    >
                      Agent
                      {sortConfig.column === 'agent' &&
                        (sortConfig.direction === 'asc' ? (
                          <ArrowUpwardIcon />
                        ) : (
                          <ArrowDownwardIcon />
                        ))}
                    </th>
                    <th
                      className='text-left py-3 px-4 cursor-pointer'
                      onClick={() => handleSort('classification')}
                    >
                      Classification
                      {sortConfig.column === 'classification' &&
                        (sortConfig.direction === 'asc' ? (
                          <ArrowUpwardIcon />
                        ) : (
                          <ArrowDownwardIcon />
                        ))}
                    </th>
                    <th
                      className='text-left py-3 px-4 cursor-pointer'
                      onClick={() => handleSort('escalation_status')}
                    >
                      Status
                      {sortConfig.column === 'escalation_status' &&
                        (sortConfig.direction === 'asc' ? (
                          <ArrowUpwardIcon />
                        ) : (
                          <ArrowDownwardIcon />
                        ))}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan='8' className='px-2 py-3'>
                      <div className='relative'>
                        <SearchIcon className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400' />
                        <input
                          type='text'
                          placeholder='Search by text'
                          value={searchTerm}
                          onChange={handleSearch}
                          className='w-full p-2 pl-10 rounded bg-gray-200'
                        />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row, index) => (
                    <tr
                      key={row.escalation_id}
                      className={`cursor-pointer ${
                        selectedCheckboxes.includes(row.application_id)
                          ? 'active-row'
                          : ''
                      }`}
                      onClick={event =>
                        handleCheckboxChange(event, index, row.escalation_id)
                      }
                      onDoubleClick={() =>
                        handleRowDoubleClick(row.application_id)
                      }
                    >
                      <td className='border px-4 py-4'>
                        <input
                          type='checkbox'
                          checked={selectedCheckboxes.includes(
                            row.escalation_id
                          )}
                          onChange={event =>
                            handleCheckboxChange(
                              event,
                              index,
                              row.escalation_id
                            )
                          }
                        />
                      </td>
                      <td className='border px-4 py-4 text-blue-500'>
                        {row.applicant_name}
                      </td>
                      <td className='border px-2 py-4 text-blue-500'>
                        {row.application_id}
                      </td>
                      <td className='border px-2 py-4 capitalize'>
                        {row.product}
                      </td>
                      <td className='border px-2 py-4'>{row.agent}</td>
                      <td className='border px-2 py-4 capitalize'>
                        {row.classification}
                      </td>
                      <td className='border px-2 py-4 text-center capitalize'>
                        {row.escalation_status}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className='flex mt-6 mr-4 justify-end space-x-4'>
        <button
          onClick={() => {
            handleApprove('Approve')
          }}
          value='Approve'
          className='bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600'
        >
          Approve
        </button>
        <button
          onClick={() => {
            handleApprove('Reject')
          }}
          value='Reject'
          className='bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-600'
        >
          Decline
        </button>
      </div>

      {selectedCheckboxes.length === 1 && (
        <div className='flex mt-4 gap-4'>
          <div className='w-1/2'>
            <h1 className='font-semibold'>
              Escalation Details (
              <span className='text-orange-600'>{selectedApplicationId}</span>)
            </h1>
            <textarea
              placeholder='Provide additional comments or escalation details...'
              className='w-full p-4 mt-2 bg-gray-200 border rounded resize-none'
              rows='6'
              value={comment}
              onChange={e => setComment(e.target.value)}
            />
          </div>

          <div className='w-1/2 grid gap-3 summary-section'>
            <div>
              <h2 className='font-semibold'>Reason for Escalation</h2>
              <p>
                This section describes why the application was flagged for
                escalation.
              </p>
            </div>
            <div>
              <h2 className='font-semibold'>Additional Comments</h2>
              <p>{comment}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EscalationOverview
